/**
 * Domain 檢測工具
 * 根據當前的 hostname 判斷使用哪個 domain 配置
 */

export const DOMAIN_TYPES = {
  DEFAULT: "default",
  KOR: "kor",
};

/**
 * 獲取當前 domain 類型
 * @returns {string} domain 類型
 */
export const getDomainType = () => {
  const hostname = window.location.hostname;

  console.log("Current hostname:", hostname); // 調試用

  // 韓國版 domain - 優先檢查
  if (hostname.includes("apptotalgo-api-test-kor.hypergsecurity.com")) {
    console.log("Detected Korean domain");
    return DOMAIN_TYPES.KOR;
  }

  // 預設 domain (包含原始 domain 和 localhost)
  if (
    hostname.includes("apptotalgo-api-test.hypergsecurity.com") ||
    hostname === "localhost" ||
    hostname === "127.0.0.1"
  ) {
    console.log("Detected default domain");
    return DOMAIN_TYPES.DEFAULT;
  }

  // 預設值
  console.log("Using fallback to default domain");
  return DOMAIN_TYPES.DEFAULT;
};

/**
 * 檢查是否為韓國版 domain
 * @returns {boolean}
 */
export const isDomainKor = () => getDomainType() === DOMAIN_TYPES.KOR;

/**
 * 檢查是否為預設 domain
 * @returns {boolean}
 */
export const isDomainDefault = () => getDomainType() === DOMAIN_TYPES.DEFAULT;

/**
 * 根據 domain 類型獲取配置
 * @param {string} domainType
 * @returns {object} domain 配置
 */
export const getDomainConfig = (domainType = null) => {
  const currentDomainType = domainType || getDomainType();

  const configs = {
    [DOMAIN_TYPES.DEFAULT]: {
      // runtime override (window._env_) -> build-time (process.env) -> hardcoded default
      apiUrl:
        (window._env_ && window._env_.REACT_APP_API_URL) ||
        process.env.REACT_APP_API_URL ||
        "https://apptotalgo-api-test.hypergsecurity.com",
      recaptchaKey:
        (window._env_ && window._env_.REACT_APP_RECAPTCHA_KEY) ||
        process.env.REACT_APP_RECAPTCHA_KEY ||
        "6LeFeOwUAAAAAKa9fS66yXGLAQ6UtFbQ1etZO0PC",
      contactEmail:
        (window._env_ && window._env_.REACT_APP_CONTACT_EMAIL) ||
        process.env.REACT_APP_CONTACT_EMAIL ||
        "AppTotalGo@hypergsecurity.com",
      defaultLanguage: "zh-TW",
      supportedLanguages: ["zh-TW", "en", "ko", "vi", "ja"],
      brandName: "AppTotalGo",
      theme: "default",
    },
    [DOMAIN_TYPES.KOR]: {
      apiUrl:
        (window._env_ && window._env_.REACT_APP_API_URL_KOR) ||
        process.env.REACT_APP_API_URL_KOR ||
        "https://apptotalgo-api-test.hypergsecurity.com",
      recaptchaKey:
        (window._env_ && window._env_.REACT_APP_RECAPTCHA_KEY_KOR) ||
        process.env.REACT_APP_RECAPTCHA_KEY_KOR ||
        "6LeFeOwUAAAAAKa9fS66yXGLAQ6UtFbQ1etZO0PC",
      contactEmail:
        (window._env_ && window._env_.REACT_APP_CONTACT_EMAIL_KOR) ||
        process.env.REACT_APP_CONTACT_EMAIL_KOR ||
        "AppTotalGo-kor@hypergsecurity.com",
      defaultLanguage: "ko",
      supportedLanguages: ["ko", "en", "zh-TW", "vi", "ja"],
      brandName: "AppTotalGo Korea",
      theme: "korea",
    },
  };

  return configs[currentDomainType] || configs[DOMAIN_TYPES.DEFAULT];
};
